import styled from 'styled-components';

import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { IFieldEditor } from '@/shared/types/fieldEditor';
import { themeVar } from '@/styles/theme';

interface OverrideAnswerProps {
  onClose: () => void;
  isOpen: boolean;
  currentField: IFieldEditor | null;
  openEditPage: (id: string, documentFieldType: string) => void;
}

const OverrideAnswer = ({ onClose, isOpen, currentField, openEditPage }: OverrideAnswerProps) => {
  if (!currentField?.linkedField) return <></>;

  const saveValue = () => {
    onClose();
    openEditPage(currentField.id, currentField.documentFieldType);
  };

  return (
    <ModalWrappedContent isOpen={isOpen} onClose={onClose} confirmButton={{ name: 'Confirm', onClick: saveValue }}>
      <ModalContainer>
        <ModalTitel>Confirmation</ModalTitel>
        <ModalText>
          This field shows the corresponding answer provided on {currentField?.linkedField?.funnelTierSection?.funnelTier?.name} by default. Do you
          want to override the default and provide a revised answer? Note that the corresponding field on{' '}
          {currentField?.linkedField?.funnelTierSection?.funnelTier?.name} will not be impacted.
        </ModalText>
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default OverrideAnswer;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalText = styled.p`
  font-weight: 400;
  font-size: 19px;
  line-height: 26.6px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
